import React from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

const ErrorMessage = ({ message, onRetry, className = "" }) => {
  return (
    <div
      className={`bg-red-50 border border-red-200 rounded-lg p-4 ${className}`}
    >
      <div className="flex items-center">
        <ExclamationTriangleIcon className="w-5 h-5 text-red-400 mr-2" />
        <div className="flex-1">
          <p className="text-sm text-red-800">{message}</p>
        </div>
        {onRetry && (
          <button
            onClick={onRetry}
            className="ml-4 text-sm text-red-600 hover:text-red-800 font-medium"
          >
            Try Again
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;
